export interface sortItemsModel {
	id: string,
	name: string
}

export const sortItemList:sortItemsModel[] = [
	{ name: 'تاریخ ایجاد', id: 'CreationTime' },
  { name: 'نام', id: 'DSName' },
  { name: 'مالک', id: 'OwnerName' },
]